export default __webpack_public_path__ + "static/media/O.8ada395e.svg";